<template>
  <div class="cont">
    <div class="title">
      <div class="s-title">人物</div>
      <div class="letter">
        <span :class="{current: current === item}" v-for="item in letters" :key="item" @click="onClickLetter(item)">{{item}}</span>
      </div>
    </div>
    <div class="clear"></div>
    <ul class="character-list">
      <li v-for="item in list" :key="item.id" @click="toDetail(item.id)">
        <div class="photo left"><img :src="item.path" :alt="item.name" :title="item.name" srcset=""></div>
        <div class="info left">
          <div class="name">{{item.title}}</div>
          <div class="position">艺术家</div>
          <div class="desc">{{item.description.substr(0, 45)}}...</div>
        </div>
      </li>
    </ul>
    <div class="clear"></div>
    <pagination :total="total" :size="12" @change="onPageChange" :curPage="pigination.page"></pagination>
  </div>
</template>

<script>
import pagination from '@/components/Pagination/Index.vue'

export default {
  name: 'Video',
  components: {
    pagination
  },
  data () {
    return {
      letters: ['全部', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'],
      current: '全部',
      list: [],
      pigination: {
        page: 1,
        size: 9
      },
      total: 0
    }
  },
  created () {
    this.loadData()
  },
  methods: {
    onClickLetter (item) {
      this.current = item
      this.pigination.page = 1
      this.loadData()
    },
    loadData () {
      let params = {
        ...this.pigination
      }
      if (this.current != '全部') {
        params = { ...params, name: this.current }
      }
      this.$http.get('/People/getPeopleList', {
        params
      })
        .then((response) => {
          if (response.data.status === 0) {
            this.list = response.data.data.list
            this.total = response.data.data.count
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    onPageChange (page) {
      // 分页发生变化时
      this.pigination.page = page
      this.loadData()
    },
    toDetail(id) {
      let {href} = this.$router.resolve({path: `/c-detail?id=${id}`});
      window.open(href, '_blank');
    }
  }
}
</script>

<style lang='less' scoped>
.cont {
  width: 980px;
  margin: 0 auto;
}
.clear {
  clear: both;
}
.title {
  line-height: 60px;
  .s-title {
    font-size: 26px;
    font-weight: bold;
    float: left;
    width: 55px;
    border-bottom: 3px solid red;
  }
  .letter {
    float: left;
    width: 900px;
    border-bottom: 3px solid #ccc;
    -moz-user-select: none;
    -khtml-user-select: none;
    user-select: none;
    padding-left: 25px;
    span {
      margin: 0 5px;
      padding: 3px 3px;

      cursor: pointer;
      &.current {
        background-color: #dc2e4c;
        color: #fff;
      }
    }
  }
}
  .character-list {
    margin-top: 20px;
    .left {
      float: left;
    }
    li {
      float: left;
      width: 310px;
      height: 145px;
      margin-right: 20px;
      margin-bottom: 25px;
      cursor: pointer;
      &:nth-child(3n) {
        margin-right: 0;
      }
      .photo {
        border: 1px solid #e0e0e0;
        width: 108px;
        height: 108px;
        margin-top: 10px;
        border-radius: 50%;
        overflow: hidden;
        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }
      .info {
        width: 180px;
        margin-left: 10px;
        .name {
          font-size: 20px;
          text-overflow:ellipsis;
          overflow: hidden;
          white-space: nowrap;
        }
        .position {
          font-size: 16px;
          margin: 10px 0;
          color: #999;
        }
        .desc {
          font-size: 14px;
          text-align: justify;
        }
      }
    }
  }
</style>
